import {
  CUSTOM_FIELD_TYPE_ADDRESS_SELECTOR,
  CUSTOM_FIELD_TYPE_COUNTRY_SELECTOR,
  CUSTOM_FIELD_TYPE_ENTITY_SELECTOR,
  CUSTOM_FIELD_TYPE_FORMATION_TYPES_SELECTOR,
  CUSTOM_FIELD_TYPE_PERSONA_SELECTOR,
  CUSTOM_FIELD_TYPE_STATE_SELECTOR,
} from "constants/aiQuestionCardFields";
import { ReactNode } from "react";
import { isSimpleFieldType, renderSimpleField } from "./CustomFieldRenderer";
import { CustomField } from "./customField.types";
import { OnLabelResolved } from "./customFieldSelector.types";
import { AutofillSelectorField } from "./fields/AutofillSelectorField";
import { CountrySelectorField } from "./fields/CountrySelectorField";
import { EntitySelectorField } from "./fields/EntitySelectorField";
import { FormationTypeSelectorField } from "./fields/FormationTypeSelectorField";
import { StateSelectorField } from "./fields/StateSelectorField";

export type CustomFieldDispatcherProps = {
  field: CustomField;
  name: string;
  groupId: string;
  entityIdFromProps?: string;
  entityFieldName?: string;
  countryFieldName?: string;
  disabled?: boolean;
  onLabelResolved: OnLabelResolved;
};

export const renderCustomField = ({
  field,
  name,
  groupId,
  entityIdFromProps,
  entityFieldName,
  countryFieldName,
  disabled,
  onLabelResolved,
}: CustomFieldDispatcherProps): ReactNode => {
  if (isSimpleFieldType(field.type)) {
    return renderSimpleField({ field, name, disabled });
  }

  switch (field.type) {
    case CUSTOM_FIELD_TYPE_ENTITY_SELECTOR:
      return (
        <EntitySelectorField
          field={field}
          name={name}
          disabled={disabled}
          onLabelResolved={onLabelResolved}
        />
      );
    case CUSTOM_FIELD_TYPE_COUNTRY_SELECTOR:
      return (
        <CountrySelectorField
          field={field}
          name={name}
          disabled={disabled}
          onLabelResolved={onLabelResolved}
        />
      );
    case CUSTOM_FIELD_TYPE_STATE_SELECTOR:
      return (
        <StateSelectorField
          field={field}
          name={name}
          countryFieldName={countryFieldName}
          entityFieldName={entityFieldName}
          entityIdFromProps={entityIdFromProps}
          disabled={disabled}
          onLabelResolved={onLabelResolved}
        />
      );
    case CUSTOM_FIELD_TYPE_FORMATION_TYPES_SELECTOR:
      return (
        <FormationTypeSelectorField
          field={field}
          name={name}
          countryFieldName={countryFieldName}
          disabled={disabled}
          onLabelResolved={onLabelResolved}
        />
      );
    case CUSTOM_FIELD_TYPE_PERSONA_SELECTOR:
      return (
        <AutofillSelectorField
          field={field}
          name={name}
          autofillType="authorized_persons"
          entityFieldName={entityFieldName}
          entityIdFromProps={entityIdFromProps}
          groupId={groupId}
          disabled={disabled}
          onLabelResolved={onLabelResolved}
        />
      );
    case CUSTOM_FIELD_TYPE_ADDRESS_SELECTOR:
      return (
        <AutofillSelectorField
          field={field}
          name={name}
          autofillType="addresses"
          entityFieldName={entityFieldName}
          entityIdFromProps={entityIdFromProps}
          groupId={groupId}
          disabled={disabled}
          onLabelResolved={onLabelResolved}
        />
      );
    default:
      return null;
  }
};
